import { Badge, Button, DatePicker, Dropdown, Form, Input, Select } from 'antd'
import moment from 'moment'
import queryString from 'query-string'
import React, { useEffect, useMemo, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Tuning2OutlineIcon } from '../../components/AppIcon'
import {
  ASSIGNEE_TYPE,
  DATE_FORMAT_DEFAULT,
  ISO_DATE_FORMAT,
  PROPOSAL_STATUS,
} from '../../constants'
import { checkValidFormFieldValue } from '../../utils/helper'

const DistributionVotesListAdvanceFilterV2 = () => {
  const [showFilter, setShowFilter] = useState(false)

  const history = useHistory()
  const location = useLocation()
  const queryStringParse = useMemo(
    () =>
      queryString.parse(location.search, {
        arrayFormat: 'index',
      }),
    [location.search]
  )

  const [form] = Form.useForm()
  const values = Form.useWatch([], form)
  const { setFieldsValue } = form

  const onToggleFilter = () => {
    setShowFilter(prev => !prev)
  }

  const hasFormValue = Object.values(values || {}).some(
    checkValidFormFieldValue
  )

  useEffect(() => {
    if (showFilter) {
      setFieldsValue({
        create_user: queryStringParse?.create_user || undefined,
        created_at:
          queryStringParse?.created_at && queryStringParse?.created_at
            ? moment(queryStringParse.created_at)
            : undefined,
        proposal_status: queryStringParse?.proposal_status || undefined,
        proposal_permission: queryStringParse?.proposal_permission || undefined,
      })
    }
  }, [queryStringParse, setFieldsValue, showFilter])

  const onFinish = values => {
    const params = {
      create_user: values?.create_user || null,
      created_at: values?.created_at
        ? moment(values?.created_at).format(ISO_DATE_FORMAT)
        : null,
      proposal_status: values?.proposal_status || null,
      proposal_permission: values?.proposal_permission || null,
    }

    const queryStringStringify = queryString.stringify(
      {
        ...params,
        keyword: queryStringParse?.keyword || null,
        page: 0,
        size: queryStringParse?.size || 10,
      },
      {
        skipNull: true,
      }
    )

    history.push(`/distribution-votes?${queryStringStringify}`)
    onToggleFilter()
  }

  const appliedFilterCount = useMemo(() => {
    let count = 0
    const hasValue = val => val && String(val).trim() !== ''

    if (hasValue(queryStringParse?.proposal_status)) count++
    if (hasValue(queryStringParse?.create_user)) count++
    if (hasValue(queryStringParse?.created_at)) count++
    if (hasValue(queryStringParse?.proposal_permission)) count++

    return count
  }, [queryStringParse])

  const handleClearFilter = () => {
    const queryStringStringify = queryString.stringify(
      {
        keyword: queryStringParse?.keyword || null,
        page: 0,
        size: queryStringParse?.size || 10,
      },
      {
        skipNull: true,
      }
    )

    history.push(`/distribution-votes?${queryStringStringify}`)
  }

  return (
    <Dropdown
      open={showFilter}
      onOpenChange={onToggleFilter}
      trigger={['click']}
      dropdownRender={() => (
        <div className="custom-page-filter-dropdown-container ">
          <Form form={form} onFinish={onFinish} layout="vertical">
            <div className="form-elements">
              <Form.Item
                label="Người gửi"
                name="create_user"
                style={{ marginBottom: 16 }}>
                <Input
                  placeholder="Lọc theo người gửi"
                  allowClear
                  className="h-40"
                />
              </Form.Item>
              <Form.Item
                label="Ngày tạo"
                name="created_at"
                style={{ marginBottom: 16 }}>
                <DatePicker
                  style={{ width: '100%' }}
                  allowClear
                  placeholder={'Lọc theo ngày tạo'}
                  format={DATE_FORMAT_DEFAULT}
                  className="h-40"
                />
              </Form.Item>

              <Form.Item
                label="Trạng thái"
                name="proposal_status"
                style={{ marginBottom: 16 }}>
                <Select
                  style={{ width: '100%' }}
                  className="h-40"
                  placeholder={'Lọc theo trạng thái'}
                  allowClear>
                  <Select.Option value={PROPOSAL_STATUS.PENDING}>
                    Chờ phê duyệt
                  </Select.Option>
                  <Select.Option value={PROPOSAL_STATUS.APPROVAL}>
                    Đã phê duyệt
                  </Select.Option>
                  <Select.Option value={PROPOSAL_STATUS.REJECT}>
                    Từ chối
                  </Select.Option>
                </Select>
              </Form.Item>
              <Form.Item
                label="Loại"
                name="proposal_permission"
                style={{ marginBottom: 16 }}>
                <Select
                  style={{ width: '100%' }}
                  className="h-40"
                  placeholder={'Lọc theo loại'}
                  allowClear>
                  <Select.Option value={ASSIGNEE_TYPE.CREATE}>
                    Đã gửi
                  </Select.Option>
                  <Select.Option value={ASSIGNEE_TYPE.HANDLER}>
                    Xử lý
                  </Select.Option>
                  <Select.Option value={ASSIGNEE_TYPE.FOLLOWER}>
                    Theo dõi
                  </Select.Option>
                </Select>
              </Form.Item>
            </div>
            <div
              style={{
                marginTop: '5px',
                display: 'flex',
                gap: '10px',
                alignItems: 'center',
                justifyContent: hasFormValue ? 'space-between' : 'center',
                padding: '0 20px',
              }}>
              <Button
                className="custom-ant-button"
                type="primary"
                htmlType="submit">
                Áp dụng
              </Button>
              <Button
                className="custom-ant-button"
                htmlType="button"
                onClick={onToggleFilter}>
                Đóng
              </Button>

              <Button
                className="custom-ant-button"
                style={{
                  display: hasFormValue ? 'flex' : 'none',
                  marginLeft: 'auto',
                }}
                htmlType="reset"
                onClick={() => {
                  form.resetFields()
                  onToggleFilter()
                  handleClearFilter()
                }}>
                Xóa
              </Button>
            </div>
          </Form>
        </div>
      )}
      placement="bottomRight">
      <Badge count={appliedFilterCount} offset={[-6, -3]}>
        <Button
          className="custom-page-filter-dropdown-btn"
          icon={
            <Tuning2OutlineIcon
              style={{
                width: 16,
                height: 16,
              }}
            />
          }
        />
      </Badge>
    </Dropdown>
  )
}

export default DistributionVotesListAdvanceFilterV2
